var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedIn2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.571,
    height: 18.571,
    viewBox: "0 0 18.571 18.571",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-linkedin-in",
    "data-name": "Icon awesome-linkedin-in",
    d: "M4.157,18.571H.307V6.173h3.85ZM2.23,4.481A2.24,2.24,0,1,1,4.46,2.23,2.249,2.249,0,0,1,2.23,4.481Zm16.337,14.09H14.725V12.536c0-1.438-.029-3.283-2-3.283-2,0-2.309,1.563-2.309,3.179v6.139H6.569V6.173h3.693V7.864h.054a4.046,4.046,0,0,1,3.643-2c3.9,0,4.613,2.566,4.613,5.9v6.811Z",
    transform: "translate(0 -0.001)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn2);
export default __webpack_public_path__ + "static/media/linkedIn-2.dbe7690a819ad2c381111938c3669f28.svg";
export { ForwardRef as ReactComponent };